import { connect } from 'react-redux';
import { fetchLiveNotificationsSettings, saveLiveNotificationsSettings } from '../../redux/actions';
import { getLiveNotificationsSettings, getLiveNotificationsIsLoading } from '../../redux/selectors';
import { getLiveNotificationsEnabled } from '../../../publicSession/selectors';
var mapStateToProps = function (state) { return ({
    settings: getLiveNotificationsSettings(state),
    isLoading: getLiveNotificationsIsLoading(state),
    enabledInitial: getLiveNotificationsEnabled(state),
}); };
var mapDispatchToProps = {
    fetchSettings: fetchLiveNotificationsSettings,
    saveSettings: saveLiveNotificationsSettings,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=LiveSettingsDropdown.container.js.map